import { render, staticRenderFns } from "./BookingPageSelector.vue?vue&type=template&id=946c176c&scoped=true"
import script from "./BookingPageSelector.vue?vue&type=script&lang=ts"
export * from "./BookingPageSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946c176c",
  null
  
)

export default component.exports